import Vue from 'vue'
import Vuex from 'vuex'
import {removeToken, setToken,setCurrentTitle} from '@/utils/auth'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    acctLoaded: false,
    acctName: '',
    compName: '',
    isAdmin: false,
    routers: [],
    routerLoaded: false,
    progress: false,
    currentTitle:''
  },
  mutations: {
    LOG_OUT: (state) => {
      state.acctLoaded = false
      state.routerLoaded = false
    },
    SET_ADMIN: (state, isAdmin) => {
      state.isAdmin = isAdmin
    },
    SET_ROUTERS: (state, routers) => {
      state.routers = routers
      state.routerLoaded = true
    },
    SET_PROGRESS: (state, progress) => {
      state.progress = progress
    },
    SET_ACCT_INFO: (state, acctName, compName) => {
      state.acctLoaded = true
      state.acctName = acctName
      state.compName = compName
    },
    SET_CURRENT_TITLE:(state,currentTitle) => {
      state.currentTitle=currentTitle
    }
  },
  actions: {
    logOut({commit}) {
      console.log("log out")
      commit('LOG_OUT')
      removeToken()
    },
    logIn({commit}, token) {
      setToken(token, 7)
    },
    acctInfoSet({commit}, {isAdmin, acctName, compName}) {
      commit('SET_ADMIN', isAdmin)
      commit('SET_ACCT_INFO', acctName, compName)

    },
    setRouters({commit}, routers) {
      commit('SET_ROUTERS', routers)
    },
    setProgress({commit}, progress) {
      commit('SET_PROGRESS', progress)
    },
    setCurretTitle({commit}, currentTitle){
      commit('SET_CURRENT_TITLE',currentTitle)
      setCurrentTitle(currentTitle, 7)
    }
  },
  modules: {},
  getters
})
